module.exports = __webpack_public_path__ + "img/Synthanzia.e3c76e63.png";